import Moment from 'moment-timezone';

export function TimeZone() {
  return Moment().tz('Asia/Kuala_Lumpur').format('YYYY-MM-DD HH:mm:ss')
}